import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle both hash URLs (#section) and path-based URLs (/section)
    const hash = location.hash.substring(1);
    const pathSection = location.pathname.split('/').pop();
    const targetId = hash || pathSection;

    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        // Small timeout ensures layout is complete
        setTimeout(() => {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
          
          // Adjust for fixed header if needed
          const headerHeight = document.querySelector('header')?.offsetHeight || 0;
          if (headerHeight > 0) {
            window.scrollBy(0, -headerHeight);
          }
        }, 100);
      }
    }
  }, [location.pathname, location.hash]); // Watch both path and hash
};

export default useScrollToHash;